import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useComponentClassName } from "../../auxiliary/useComponentClassName.js";
const Aether = memo(({ children, className, ...divProps }) => /* @__PURE__ */ jsx("div", { className: classNames(useComponentClassName("aether"), className), ...divProps, children }));
Aether.displayName = "Aether";
export {
  Aether
};
//# sourceMappingURL=Aether.js.map
